
























import Vue from 'vue';
import { Theme } from '@/models';

export default Vue.extend({
  name: 'AuthenticationServerNotRespondingView',
  computed: {
    currentTheme(): Theme {
      return this.$store.state.themes.current;
    },
  },
});
